// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"378":"f1b59c08","433":"89871434","488":"075490a1","590":"760025fc","852":"5420bd15","882":"2ebbb419","954":"8a234f16"}[chunkId] + ".chunk.js";
};